
































import Vue from 'vue'
import _  from 'lodash'
import { DxColumn, DxDataGrid, DxScrolling, DxSelection, DxSorting } from 'devextreme-vue/data-grid'
import { GetArchiveResponse, GetPdfUrlResponse } from '@/types/service-response'
import { GET_PROJECT_ARCHIVE_LIST, GET_PROJECT_PDF, GET_PROJECT_PDF_NAME } from '@/store/action-types'
import { ProjectArchive } from '@/model/project/ProjectArchive'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  archiveList: ProjectArchive[]
  selectedRow: ProjectArchive | undefined
  pdfLink: string | undefined
  pdfName: string
}

export default Vue.extend({
  name: 'ProjectArchive',

  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSorting,
    DxSelection
  },

  props: {
    belegId: Number,
    refreshLoading: Boolean
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      archiveList: [],
      selectedRow: undefined,
      pdfLink: undefined,
      pdfName: ''
    }
  },

  watch: {
    belegId (newVal: number): void {
      if(newVal && newVal !== 0) {
        this.archiveList = []
        this.selectedRow = undefined
        this.pdfLink = undefined
        this.pdfName =  ''
        this.fetchData()
      } else {
        this.archiveList = []
        this.selectedRow = undefined
        this.pdfLink = undefined
        this.pdfName =  ''
      }
    },

    refreshLoading (newVal: boolean): void {
      if(newVal) {
        this.fetchData()
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    }
  },

  methods: {
    onRowClick (data: any): void {
      this.selectedRow = this.archiveList[data.rowIndex]
      if(this.selectedRow) {
        this.getPDF(this.selectedRow.id)
      }
    },

    async getPDF (payload: number): Promise<void> {
      //const baseURL =  process.env.VUE_APP_API_ROOT || ''
      try {
      const response: GetPdfUrlResponse = await this.$store.dispatch(GET_PROJECT_PDF_NAME, payload)
      if(!response.IsError && response.Name) {
        this.pdfName = response.Name
        //this.pdfLink = `${response.Url}#toolbar=1`
      }
      } catch {

      }

      try {
        const pdfResponse: any = await this.$store.dispatch(GET_PROJECT_PDF, payload)
        //const url = window.URL.createObjectURL(new Blob([pdfResponse]))
        const file = new Blob(
            [pdfResponse],
            { type: 'application/pdf' })
        const fileURL = URL.createObjectURL(file);
        this.pdfLink = `${fileURL}#toolbar=1`
        //this.pdfLink = `${baseURL}/api/Archive/GetPdfById?archiveId=${payload}#toolbar=1`
      } catch {
        this.messageSnackbar = this.$t('project.projectReprint.previewErrorMessage')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchData (): Promise<void> {
      try {
        const response: GetArchiveResponse = await this.$store.dispatch(GET_PROJECT_ARCHIVE_LIST, this.belegId)
        if (!response.IsError && response.Archives) {
          this.archiveList = ProjectArchive.createFromResponse(response.Archives)
          this.archiveList = _.orderBy(this.archiveList, ['version', 'formular'], ['desc', 'asc'])
          if (this.archiveList && this.archiveList[0]) {
            //@ts-ignore
            setTimeout(() => {
              //@ts-ignore
              this.$refs.dataGrid.instance.selectRows([this.archiveList[0].id])
              this.selectedRow = this.archiveList[0]
              this.getPDF(this.selectedRow.id)
            }, 100)
          }
        } else {
          this.messageSnackbar = this.$t('project.projectReprint.refreshErrorMessage')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('project.projectReprint.refreshErrorMessage')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.$emit('stopRefreshLoading')
      }
    }
  },

  mounted () {
    if(this.belegId) {
      this.fetchData()
    }
  }
})
